import { render, staticRenderFns } from "./ruleGroup.vue?vue&type=template&id=704e1799&scoped=true&"
import script from "./ruleGroup.vue?vue&type=script&lang=js&"
export * from "./ruleGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704e1799",
  null
  
)

export default component.exports